import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';
import { Divider } from 'inpock-ui-react';

import IconDiscount from '@/assets/icons/icon-discount.svg';
import IconInstagram from '@/assets/icons/icon-instagram.svg';

export const DiscountBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;

  padding: 12px 14px;
  background-color: rgba(100, 123, 255, 0.06);
  border: 1px solid ${colors.blue};
  border-radius: 10px;

  color: #3646b4;
  font-size: 14.8px;
  font-weight: 300;
  user-select: none;

  .discount-icon {
    background-image: url(${IconDiscount});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 22px;
    height: 22px;
  }
`;

export const ProductDivider = styled(Divider)`
  height: 4px !important;
  margin-top: 20px !important;
  margin-bottom: 8px !important;
  background-color: ${colors.gray100} !important;
  width: calc(100% + 24px) !important;
  margin-left: -12px !important;
`;

export const Instagram = styled.div`
  background-image: url(${IconInstagram});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 24px;
  height: 24px;
  margin-left: 10px;
`;
